import antd, { Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import React from 'react';
import { Redirect, RouteProps, NavLink } from 'react-router-dom';
import AuthContext from '../../../Context/AuthContext';
import FormControl from '../../Forms/FormControl';
import { StyleLoginForm, TextLinksFormItem } from './LoginForm.Style';
import { LoginFormHandler } from './LoginFormHandler';
import ValidationUtility from 'Core/ValidationUtility';
import ReCaptcha from '../../ReCaptcha/ReCaptcha';
import LoginUtility from '../../../Core/LoginUtility';
import { SubmitButton } from 'components/SubmitButton';

const { Form, Icon, Input, Button, Checkbox } = antd;

export interface Props extends FormComponentProps, RouteProps {
  children?: React.ReactNode;
}

export interface State {
  isLoggedIn: boolean;
}

class BaseLoginForm extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  loginFormHandler: LoginFormHandler;
  recaptchaInstance;

  constructor(props: Props) {
    super(props);
    this.loginFormHandler = new LoginFormHandler(props);
    this.state = { isLoggedIn: false };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.recaptchaInstance = React.createRef();
  }

  componentDidMount() {
    if (this.context.data) {
      this.setState({ isLoggedIn: true });
    }
  }

  handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.loginFormHandler
          .RequestLogin(values)
          .then(user => {
            this.context.Update(user);
            setTimeout(() => {
              this.setState({ isLoggedIn: true });

            }, 1000);

            //Reset login attempt count after successful login
            LoginUtility.ResetLoginAttemptCount();
          })
          .catch(() => {
            //Call a counter to keep track of failed login attempts
            LoginUtility.IncrementLoginAttempt();
          })
          .finally(() => {
            if (LoginUtility.GetLoginAttemptCount() >= 3) {
              //reset recaptcha
              this.resetRecaptcha();
            }
          });
      }
    });
  }

  resetRecaptcha = () => {
    if (this.recaptchaInstance.current) {
      this.recaptchaInstance.current.reset();
      this.props.form.resetFields(['reCaptchaToken']);
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let state: { from?: any; noPermission?: boolean } = {};

    if (this.props.location) {
      state = this.props.location.state || {};
    }

    if (this.state.isLoggedIn) {
      return this.ShouldRedirectTo(state) ? <Redirect to={state.from} /> : <Redirect to="/" />;
    }

    return (
      <StyleLoginForm onSubmit={this.handleSubmit}>
        <FormControl
          getFieldDecorator={getFieldDecorator}
          rules={[{ required: true, message: 'Please input your Email Address' }]}
          name="username">
          <Input
            name="username"
            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="Email"
          />
        </FormControl>
        <FormControl
          getFieldDecorator={getFieldDecorator}
          rules={[{ required: true, message: 'Please input your Password' }]}
          name="password">
          <Input.Password
            visibilityToggle={true}
            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="Password"
          />
        </FormControl>

        {/* if login attempts fail 3 or more times show recaptcha  */}
        {LoginUtility.GetLoginAttemptCount() >= 3 ? (
          // ReCAPTcha
          <FormControl
            getFieldDecorator={getFieldDecorator}
            rules={[...ValidationUtility.getRequired('Please check the checkbox')]}
            name="reCaptchaToken"
            valuePropName="checked">
            <ReCaptcha reCaptchaID="loginReCaptcha" ref={this.recaptchaInstance} />
          </FormControl>
        ) : null}

        <TextLinksFormItem>
          {/* {getFieldDecorator('remember', {
            valuePropName: 'checked',
            initialValue: true,
          })(<Checkbox>Remember me</Checkbox>)} */}
          <NavLink to="/forget-password" className="login-form-forgot" >
            Forgot password?
          </NavLink>
          <SubmitButton className="login-form-button" type="primary" htmlType="submit" style={{ textAlign: "center" }}>Log in</SubmitButton>
          <NavLink to="/sign-up">Register now!</NavLink>
          <br />
          Already Registered? <NavLink to="/emailconfirmation">Confirm email</NavLink>
          <br />
          <NavLink to="/resend-emailconfirmation">Resend registration token email</NavLink>
        </TextLinksFormItem>
        <Row>
          <Col />
        </Row>
      </StyleLoginForm>
    );
  }

  private ShouldRedirectTo(state: { from?: any; noPermission?: boolean | undefined }): boolean {
    return !!state.from && state.from.pathname !== '/logout';
  }
}

const LoginForm = Form.create<Props>({
  name: 'Login',
})(BaseLoginForm);

export default LoginForm;
